module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("ALSO BY AILEEN ERIN")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Complete Alpha Girls Series")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/becoming-alpha",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Becoming Alpha")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/avoiding-alpha",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Avoiding Alpha")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/alpha-divided",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Alpha Divided")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/bruja",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Bruja")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/alpha-unleashed",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Alpha Unleashed")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/shattered-pack",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Shattered Pack")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/being-alpha",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Being Alpha")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/lunar-court",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Lunar Court")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/alpha-erased",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Alpha Erased")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Shadow Ravens Series")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_c('i', [_vm._v("Cipher")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Aunare Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/off-planet",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Off Planet")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/off-balance",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("Off Balance")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/in-command",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("In Command")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/on-mission",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("On Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/on-destiny",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("On Destiny")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5a8884","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-aileen-erin.vue
// module id = 66
// module chunks = 0